import { useEffect, useState, useRef } from "react";

const FloatingOrderButton = ({ order = [], sum = 0, setShowModal }) => {
    const [visible, setVisible] = useState(false);
    const [pop, setPop] = useState(false);
    const prevOrderLength = useRef(order.length);

    useEffect(() => {
        setVisible(order.length > 0);

        // Trigger animation only when an item is added
        if (order.length > prevOrderLength.current) {
            setPop(true);
            setTimeout(() => setPop(false), 300); // match animation duration
        }

        prevOrderLength.current = order.length;
    }, [order]);

    return (
        <div
            className={`btn btn-primary position-fixed py-2 px-3 shadow-lg rounded-3 primaryText ${
                visible ? "fade-in" : "fade-out"
            } ${pop ? "pop" : ""}`}
            style={{
                left: "50%",
                bottom: visible ? "4%" : "-50px",
                transform: "translateX(-50%)",
                transition: "bottom 0.3s ease-in-out, opacity 0.3s ease-in-out",
                opacity: visible ? 1 : 0,
                pointerEvents: visible ? "auto" : "none",
                width: "80%",
                maxWidth: "350px",
                fontSize: "14px",
                color: "#333",
            }}
            onClick={() => setShowModal(true)}
        >
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                    <span
                        className="badge text-white rounded-pill d-flex align-items-center justify-content-center"
                        style={{
                            width: "24px",
                            height: "24px",
                            fontSize: "12px",
                            fontWeight: "900",
                            padding: "3px 4px 4px 4px",
                            background: "#3e3e3e"
                        }}
                    >
                        {order.length}
                    </span>
                    <p className="m-0 fw-semibold fs-6">Gå till kassan</p>
                </div>
                <p className="m-0 fw-bold fs-6">{sum.toFixed(2)} kr</p>
            </div>
        </div>
    );
};

export default FloatingOrderButton
